import { CheckCircle, Star, Award, Shield } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const TrustBadges = () => {
  const badges = [
    {
      icon: <CheckCircle className="h-8 w-8" />,
      title: "500+ Happy Pets",
      description: "Groomed with care"
    },
    {
      icon: <Star className="h-8 w-8" />,
      title: "5-Star Rated",
      description: "Service excellence"
    },
    {
      icon: <Award className="h-8 w-8" />,
      title: "Certified Groomers",
      description: "Professional team"
    },
    {
      icon: <Shield className="h-8 w-8" />,
      title: "Fully Insured",
      description: "Your peace of mind"
    }
  ];

  return (
    <section className="py-16 bg-warm-white/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Trusted by Denver Pet Parents
          </h2>
          <p className="text-xl text-muted-foreground">
            Your pet's safety and happiness is our top priority
          </p>
        </div>
        
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {badges.map((badge, index) => (
            <Card 
              key={index} 
              className="text-center p-6 shadow-soft hover:shadow-accent hover:-translate-y-1 transition-all duration-300"
            >
              <CardContent className="space-y-3 p-0">
                <div className="w-16 h-16 mx-auto bg-primary/10 rounded-full flex items-center justify-center text-primary">
                  {badge.icon}
                </div>
                <div>
                  <h3 className="font-bold text-lg">{badge.title}</h3>
                  <p className="text-sm text-muted-foreground">{badge.description}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;